/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit More/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import AppointmentHistory from './AppointmentHistory/index'
import Audit from './Audit/index'
import Cancel from './Cancel/index'
import ChangeAppointmentType from './ChangeAppointmentType/index'
import Diagnosis from './Diagnosis/index'
import GenerateLetters from './GenerateLetters/index'
import MoveToAnotherTreatment from './MoveToAnotherTreatment/index'
import OldGenerateLetters from './OldGenerateLetters/index'
import React from 'react'
import ThreeDotsMenu from 'DesignSystem/ThreeDotsMenu/index'
import ToothChart from './ToothChart/index'



/** @type {import('Simple/types.js').View} */
export default function More({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Actions/Scheduled/More"
  
}) {
let optionsValueData = fromData.useDataValue({ viewPath,
context: 'options',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<ThreeDotsMenu
  viewPath={`${viewPath}/ThreeDotsMenu`}
 onClick={onClick}
 data="options"
 from={optionsValueData}
 paddingTop={0}
 paddingLeft={0}
 paddingBottom={0}
 paddingRight={0}
 left="-230px"
 height="auto"
 width={250}
 valueWidth="auto"
 selectedBackgroundColor="transparent"
 alignSelf="center"
 marginLeft={dtSpaceXxs}
/>
<AppointmentHistory
  viewPath={`${viewPath}/AppointmentHistory`}
/>
<GenerateLetters
  viewPath={`${viewPath}/GenerateLetters`}
/>
<OldGenerateLetters
  viewPath={`${viewPath}/OldGenerateLetters`}
/>
<Diagnosis
  viewPath={`${viewPath}/Diagnosis`}
/>
<ToothChart
  viewPath={`${viewPath}/ToothChart`}
/>
<Cancel
  viewPath={`${viewPath}/Cancel`}
/>
<Audit
  viewPath={`${viewPath}/Audit`}
/>
<ChangeAppointmentType
  viewPath={`${viewPath}/ChangeAppointmentType`}
/>
<MoveToAnotherTreatment
  viewPath={`${viewPath}/MoveToAnotherTreatment`}
/>
{children}
</React.Fragment>)
}